import { IEnvironment, defaultEnvironment } from '@geovelo-frontends/commons';

let _environment: IEnvironment & {
  amplitude: { apiKey: string };
  config: { coveloCommunitiesCodes: string[] };
  highlightedEventIds?: number[];
  features: {
    equipment: 'all' | 'onlyStaff';
  };
} = {
  ...defaultEnvironment,
  source: 'website',
  apiKey: '0f8c781a-b4b4-4d19-b931-1e82f22e769f',
  config: { coveloCommunitiesCodes: ['lyon'] },
  crisp: { websiteId: '1e1dfe74-a0e3-4f05-b0fd-c260f626189f' },
  amplitude: { apiKey: 'ac4733e65fab456f59d59f3a426eb5c6' },
  features: { equipment: 'onlyStaff' },
};

if (!process.env.GATSBY_APP_ENV || process.env.GATSBY_APP_ENV === 'development') {
  _environment = {
    ..._environment,
    highlightedEventIds: [35],
    features: {
      ..._environment.features,
      equipment: 'all',
    },
  };
}

if (process.env.GATSBY_APP_ENV === 'staging') {
  _environment = {
    ..._environment,
    apiKey: '0f8c781a-b4b4-4d19-b931-1e82f22e769f',
    highlightedEventIds: [156],
  };
}

if (process.env.GATSBY_APP_ENV === 'production') {
  _environment = {
    ..._environment,
    apiKey: '0f8c781a-b4b4-4d19-b931-1e82f22e769f',
    highlightedEventIds: [156],
  };
}

const environment = _environment;

export default environment;
